import React from 'react'
import classNames from 'classnames'
import { faChair, faWheelchair } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SEAT_TYPES } from '../constants'

const SeatLabel = (props) => {
  const {
    price,
    row,
    seat,
    status,
    section,
    color,
    top,
    left,
    visible,
    showReserveButton,
    tierNames,
    seatLabelPriceText = 'Price',
    buyerInfo,
    initializeListeners,
    initializeReservationButtonListeners,
    seatType = SEAT_TYPES.CHAIR
  } = props

  const showPrice = seatLabelPriceText && price

  return visible ? (
    <div
      className='seatLabelContainer'
      style={{ top, left }}
      ref={initializeListeners}
    >
      <div className='seatLabelRect'>
        <div className='seatLabelHeader'>
          <FontAwesomeIcon
            className='seatLabelIcon'
            icon={seatType === SEAT_TYPES.WHEELCHAIR ? faWheelchair : faChair}
          />
          <span>Seat Information</span>
        </div>
        <div
          className={classNames({
            'seatLabelContent seatLabelContent-large': showReserveButton,
            seatLabelContent: !showReserveButton
          })}
        >
          <div className='seatLabelRow'>
            {showPrice && (
              <div className='seatLabelItem'>
                <div className='seatLabelItemTitle'>{seatLabelPriceText}</div>
                <div className='seatLabelItemText'>{price}</div>
              </div>
            )}
            {Boolean((row || '').trim()) && (
              <div className='seatLabelItem'>
                <div className='seatLabelItemTitle'>Row</div>
                <div className='seatLabelItemText'>
                  {row || seat.match(/[a-zA-Z]+/g)}
                </div>
              </div>
            )}
            <div className='seatLabelItem'>
              <div className='seatLabelItemTitle'>Seat No.</div>
              <div className='seatLabelItemText'>
                {row ? seat : seat.match(/\d+/g)}
              </div>
            </div>
          </div>
          <div className='seatLabelRow'>
            <div className='seatLabelItem'>
              <div className='seatLabelItemTitle'>Status</div>
              <div className='seatLabelItemText' style={{ color }}>
                {status}
              </div>
            </div>
            <div
              className={classNames({
                'seatLabelItem flex2': showPrice,
                seatLabelItem: !showPrice
              })}
            >
              <div className='seatLabelItemTitle'>Section</div>
              <div className='seatLabelItemText'>
                {section + (tierNames ? ` (${tierNames})` : '')}
              </div>
            </div>
          </div>
          {showReserveButton && (
            <div className='seatLabelRow'>
              <div className='seatLabelItem'>
                <button
                  className='seatLabelButton'
                  ref={initializeReservationButtonListeners}
                >
                  Reserve
                </button>
              </div>
            </div>
          )}
        </div>
        {buyerInfo && (
          <div className='seatLabelContent withBuyerInfo'>
            <div className='seatLabelRow'>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Buyer</div>
                <div className='seatLabelItemText'>{buyerInfo.name}</div>
              </div>
            </div>
            <div className='seatLabelRow'>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Buyer Email</div>
                <div className='seatLabelItemText'>{buyerInfo.email}</div>
              </div>
            </div>
            <div className='seatLabelRow'>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Order ID</div>
                <div className='seatLabelItemText'>{buyerInfo.order}</div>
              </div>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Ticket Hash</div>
                <div className='seatLabelItemText'>{buyerInfo.ticket}</div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className='seatLabelTriangle' />
    </div>
  ) : null
}

export { SeatLabel }
